import { CommonModule } from '@angular/common';
import { Component, signal } from '@angular/core';
import {
  FormBuilder,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSnackBar } from '@angular/material/snack-bar';
import { map } from 'rxjs';
import { ContactUsFormService } from 'src/app/services/contact-us-form.service';

@Component({
  selector: 'app-contact-us-sheet',
  imports: [
    FormsModule,
    CommonModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatInputModule,
    MatButtonModule,
    MatProgressBarModule,
  ],
  templateUrl: './contact-us-sheet.component.html',
  styleUrl: './contact-us-sheet.component.css',
})
export class ContactUsSheetComponent {
  isLoading = signal(false);
  contactUsForm = this.fb.group({
    contactName: ['', Validators.required],
    email: ['', [Validators.required, Validators.email]],
    companyName: ['', Validators.required],
    phone: [0, Validators.pattern('[- +()0-9]{10,}')], // regex for numbers 0-9 and at least 6 digits
    subject: ['Web Platform Contact Us Form Inquiry', Validators.required],
    message: [null, Validators.required],
  });

  constructor(
    private _bottomSheetRef: MatBottomSheetRef<ContactUsSheetComponent>,
    private fb: FormBuilder,
    private contactUsService: ContactUsFormService,
    private snackbar: MatSnackBar
  ) {}

  onSubmit() {
    if (this.contactUsForm.valid) {
      // send form data to gql server
      this.contactUsService
        .mutate({
          input: {
            ...this.contactUsForm.value,
            phone: `${this.contactUsForm.get('phone').value}`, // graphql parameter is string and form phone field type is number
          },
        })
        .pipe(map(() => this.isLoading.set(true)))
        .subscribe({
          next: (res) => {
            this.snackbar.open(
              `Thank you for contacting us. We will be in touch with you via email`,
              null,
              {
                duration: 4300,
                panelClass: ['blue-snackbar'],
              }
            );
            this._bottomSheetRef.dismiss();
            this.isLoading.set(false);
          },
          error: (err) => {
            this.snackbar.open(`Error. Unable to send`, null, {
              duration: 4400,
              panelClass: ['blue-snackbar'],
            });
            this.isLoading.set(false);
            console.log('err', err);
          },
        });
    } else {
      console.log('invalid');
      this.isLoading.set(false);
      this.snackbar.open(`Unable to send Check form fields`, null, {
        duration: 4300,
        panelClass: ['blue-snackbar'],
      });
    }
  }
}
